import TermsServices from '../../services/TermsServices'
import TermsType from '../../code/TermsType'
import CodeUpdate from '../../code/CodeUpdate'

const types = {
  GET_PRIVACY_POLICY_LIST: '@terms/GET_PRIVACY_POLICY_LIST',
  SET_ACTIVE_PRIVACY_POLICY: '@terms/SET_ACTIVE_PRIVACY_POLICY',
  GET_AGREEMENT_LIST: '@terms/GET_AGREEMENT_LIST',
  ACCEPT_TERMS: '@terms/ACCEPT_TERMS',
  CODE_UPDATE: '@terms/CODE_UPDATE',
  GET_MY_AGREEMENT: '@terms/GET_MY_AGREEMENT',
  GET_MY_IS_AGREEMENT: '@terms/GET_MY_IS_AGREEMENT'
}

export {
  types as termsTypes
}

export default {
  namespaced: true,
  state: {
    activePrivacyPolicy: {},
    privacyPolicyList: {
      resultData: []
    },
    agreementList: {
      resultData: []
    },
    acceptTermList: [],
    codeTermAccept: CodeUpdate.READY,
    isAgreement: null,
    isPrivacyPolicy: null,
    termsLatest: {},
    termsHistory: []
  },

  getters: {
    privacyPolicyList: (state) => {
      return state.privacyPolicyList
    },
    activePrivacyPolicy: (state) =>  {
      return state.activePrivacyPolicy
    },
    agreementList: (state) => {
      return state.agreementList
    },
    agreementFirst: (state) => {
      if (state.agreementList.resultData.length > 0) {
        return state.agreementList.resultData[0]
      }
      return {}
    },
    codeTermAccept: (state) => state.codeTermAccept,
    isAgreement: (state) => state.isAgreement,
    isPrivacyPolicy: (state) => state.isPrivacyPolicy,
  },

  mutations: {
    [types.GET_PRIVACY_POLICY_LIST] (state, payload) {
      state.privacyPolicyList = payload.privacyPolicyList
      if (payload.privacyPolicyList.resultData.length > 0) {
        state.activePrivacyPolicy = payload.privacyPolicyList.resultData[0]
      }
    },
    [types.GET_AGREEMENT_LIST] (state, payload) {
      state.agreementList = payload.agreementList
    },
    [types.SET_ACTIVE_PRIVACY_POLICY] (state, payload) {
      state.activePrivacyPolicy = payload.activePrivacyPolicy
    },
    [types.ACCEPT_TERMS] (state, payload) {
      state.acceptTermList = [...state.acceptTermList, payload.acceptTerms]
    },
    [types.CODE_UPDATE] (state, payload) {
      state.codeTermAccept = payload.codeTermAccept
    },
    [types.GET_MY_AGREEMENT] (state, payload) {
      state.isAgreement = payload.isAgreement
      state.isPrivacyPolicy = payload.isPrivacyPolicy
      state.termsLatest = payload.termsLatest
    },
    [types.GET_MY_IS_AGREEMENT] (state, payload) {
      state.isAgreement = payload.isAgreement
      state.isPrivacyPolicy = payload.isPrivacyPolicy
    }

  },

  actions: {
    async getMyAgreement ({commit}) {
      commit(types.GET_MY_AGREEMENT, {
        isAgreement : true,
        isPrivacyPolicy : true,
        termsLatest: null,
        termsHistory: null
      })

    },
    async getPrivacyPolicyList ({ commit }) {
      commit(types.GET_PRIVACY_POLICY_LIST, {
        privacyPolicyList: null
      })
    },
    async setActivePrivacyPolicy ({state, commit}, payload) {
      if (activePrivacyPolicy) {
        commit(types.SET_ACTIVE_PRIVACY_POLICY, null)
      }
    },
    async getAllTerms ({dispatch}) {
      await dispatch('getAgreementList')
      await dispatch('getPrivacyPolicyList')
    },
    async acceptTerms ({commit}, payload) {
      const acceptTermList = payload.acceptTermList
      return acceptTermList
    },
    acceptedAgreement({commit}){
      commit(types.GET_MY_IS_AGREEMENT, {isAgreement: true, isPrivacyPolicy: true})
    }
//     commit(types.GET_MY_AGREEMENT, {
//   isAgreement,
//     isPrivacyPolicy,
//     termsLatest: responseLatest.data.resultData,
//     termsHistory: responseHistory.data.resultData
// })

}
}



// WEBPACK FOOTER //
// ./src/store/modules/terms.js